import {useEffect,useState} from 'react';
import {Linking,Platform} from 'react-native';
import {fleetInvitationCode} from '../shared/fleet-invitation-link.js';

export function useFleetInvitationLink(){
 const [code,setCode]=useState<string|null>(()=>Platform.OS==='web'&&typeof window!=='undefined'?fleetInvitationCode(window.location.hash):null);
 useEffect(()=>{
  if(Platform.OS==='web'){
   const read=()=>setCode(fleetInvitationCode(window.location.hash));
   window.addEventListener('hashchange',read);return()=>window.removeEventListener('hashchange',read);
  }
  let active=true;void Linking.getInitialURL().then(url=>{if(active)setCode(fleetInvitationCode(url));}).catch(()=>{});
  const listener=Linking.addEventListener('url',({url})=>setCode(fleetInvitationCode(url)));
  return()=>{active=false;listener.remove();};
 },[]);
 const handled=()=>{
  setCode(null);
  if(Platform.OS==='web'&&typeof window!=='undefined'&&fleetInvitationCode(window.location.hash))window.history.replaceState(null,'',window.location.pathname+window.location.search);
 };
 return {code,handled};
}
